module.exports = __webpack_public_path__ + "static/media/profile-chevron.7d3bb1b8.svg";